import './naracafe/style';
import FormStructure from './naracafe/form_structure';

export default FormStructure;